module.exports = __webpack_public_path__ + "static/talks2-f66d170e81f337858893bfbf1f6e50c1.jpg";